import type { ComponentType, SVGProps } from 'react';
import {
  IconBike,
  IconBinoculars,
  IconDroplet,
  IconFire,
  IconFish,
  IconFlower,
  IconHiking,
  IconKayak,
  IconLeaf,
  IconMountain,
  IconSun,
  IconTent,
  IconTrees,
  IconWaterfall,
  IconWaves,
} from '../components/icons';

type IconProps = SVGProps<SVGSVGElement> & { size?: number };

/**
 * One unique nature/sports icon per city of Serra do Itaqueri. Source:
 * https://itaqueriturismo.com.br/cidades/ — 15 cities, 15 distinct icons.
 * Slugs use the same ASCII-lowercase-hyphen convention as SlugHelper on
 * the backend, so they match whatever `Address.City` produces.
 */
const cityIconMap: Record<string, ComponentType<IconProps>> = {
  'aguas-de-sao-pedro':   IconDroplet,    // águas termais / balneário
  analandia:              IconMountain,   // relevo acidentado da Cuesta
  brotas:                 IconWaves,      // rios e rafting
  charqueada:             IconHiking,     // trilhas e atividades outdoor
  corumbatai:             IconFish,       // rio Corumbataí, pesca
  dourado:                IconSun,        // charme rural, campo
  ipeuna:                 IconBike,       // ecoturismo e aventura
  itirapina:              IconWaterfall,  // cachoeiras da serra
  limeira:                IconLeaf,       // Capital da Laranja
  piracicaba:             IconKayak,      // rio Piracicaba
  'rio-claro':            IconTent,       // camping e cerrado
  'santa-maria-da-serra': IconBinoculars, // represa de Barra Bonita
  'sao-carlos':           IconTrees,      // atrações naturais + cerrado
  'sao-pedro':            IconFire,       // destino de aventura
  torrinha:               IconFlower,     // coração da Serra do Itaqueri
};

/** Nature-themed fallback for any slug not yet mapped. */
const DefaultIcon = IconMountain;

export function CityIcon({ slug, size = 28 }: { slug: string; size?: number }) {
  const Icon = cityIconMap[slug] ?? DefaultIcon;
  return <Icon size={size} />;
}
